module.exports = __webpack_public_path__ + "static/SNG1-ee67367c06a11bbdf90bbf3c9a5914f9.png";